import type { ChatMessage } from '@elara/client-core/models/ChatMessageModel';
import type { MessageUiState } from '@elara/client-core/states/MessageUiState';

import { formatStoppedResponseLabel } from '@elara/client-core/chat/stopped-response';

import { MessageContentRenderer } from '#ui/chat/MessageContentRenderer.js';
import { MessageContextProvider } from '#ui/chat/MessageContext.js';
import { MessageThinkingIndicator } from '#ui/chat/MessageThinkingIndicator.js';
import { Card } from '#ui/index.js';

interface ModelMessageCardProps {
  msg: ChatMessage;
  state: MessageUiState;
  showThinkingIndicator?: boolean;
}

export function ModelMessageCard({ msg, state, showThinkingIndicator = false }: ModelMessageCardProps) {
  const messageRef = msg.chatId && msg.id ? { chatId: msg.chatId, messageId: msg.id } : undefined;

  return (
    <MessageContextProvider messageRef={messageRef} isGenerating={msg.isOptimistic || msg.isGenerating}>
      <Card className={'pb-2 py-1 bg-transparent dark:border-0 flex flex-col gap-4'}>
        {state.content.length > 0 && <MessageContentRenderer content={state.content} state={state} />}
        {showThinkingIndicator && !msg.wasStopped && <MessageThinkingIndicator state={state} />}
        {msg.wasStopped && (
          <p className="text-xs italic text-muted-foreground">{formatStoppedResponseLabel(msg.stoppedDurationMs)}</p>
        )}
      </Card>
    </MessageContextProvider>
  );
}
